/* @ngInject */
function AuditSocialMediaFiltersController ($rootScope, $scope, $q, $stateParams, $timeout, $translate, ToastService, GroupService, SocialMediaService) {
  const socialType = 'instagram'

  $scope.locale = $rootScope.oUser.locale

  $scope.filterData = {
    accounts: {
      options: [],
      value: [],
      hasMoreResults: false,
      top: 10,
      skip: 0
    },
    groups: {
      options: [],
      value: [],
      hasMoreResults: false,
      top: 10,
      skip: 0
    },
    contentType: {
      options: [],
      value: [],
      hasMoreResults: false
    },
    nonConformity: {
      options: [],
      value: []
    },
    date: {
      maxDate: new Date().toISOString(),
      start: '',
      end: ''
    }
  }

  $scope.accountValue = []

  const api = {
    _getAllFilters,
    _successGetAllFilters,
    _createAccountsFilter,
    _createGroupsFilter,
    _createContentTypeFilter,
    _createNonConformityFilter,
    _getAccounts,
    _getContentType,
    _getNonConformity,
    _getGroups,
    _mountOptions,
    _hasMoreResults,
    _getMoreResults,
    _setAccountsFilterValue
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._getAllFilters()
  }

  $scope.onChange = (event, type) => {
    const isArray = Array.isArray(event.detail)

    if (isArray) {
      const options = event.detail
      $scope.filters[type] = options.map(option => option.value)
      return
    }

    const option = event.detail
    $scope.filters[type] = option
  }

  $scope.onSearch = (event, type) => {
    if ($scope.filterData[type]) {
      $scope.filterData[type].skip = 0
    }

    const search = event.detail?.search || ''
    const totalCount = event.detail?.totalCount

    const top = $scope.filterData[type]?.top
    const skip = $scope.filterData[type]?.skip

    api._getMoreResults(type, top, skip, search, totalCount)
  }

  $scope.onInfinite = (event, type) => {
    const search = event.detail?.search || ''
    const totalCount = event.detail?.totalCount

    const top = $scope.filterData[type]?.top
    const skip = top + $scope.filterData[type]?.skip

    api._getMoreResults(type, top, skip, search, totalCount)
  }

  function _getAllFilters () {
    const top = 10
    const skip = 0

    const promises = [
      api._getAccounts(top, skip),
      api._getGroups(top, skip)
    ]

    $q.all(promises).then(api._successGetAllFilters)
  }

  function _successGetAllFilters (response) {
    const [accountsData, groupsData] = response
    const contentTypeOptions = api._getContentType()
    const nonConformityOptions = api._getNonConformity()

    api._createAccountsFilter(accountsData)
    api._createGroupsFilter(groupsData)
    api._createContentTypeFilter(contentTypeOptions)
    api._createNonConformityFilter(nonConformityOptions)
  }

  function _createAccountsFilter (response) {
    const options = response.rows
    const count = response.count
    const hasMoreResults = api._hasMoreResults(count, options.length)

    $scope.filterData.accounts.options = api._mountOptions(options)
    $scope.filterData.accounts.hasMoreResults = hasMoreResults

    const accountId = $stateParams.accountId

    if (accountId) {
      api._setAccountsFilterValue(accountId)
    }
  }

  function _createGroupsFilter (response) {
    const options = response.d.results
    const count = response.d.__count
    const hasMoreResults = api._hasMoreResults(count, options.length)

    $scope.filterData.groups.options = api._mountOptions(options)
    $scope.filterData.groups.hasMoreResults = hasMoreResults
  }

  function _createContentTypeFilter (options) {
    $scope.filterData.contentType.options = options
  }

  function _createNonConformityFilter (options) {
    $scope.filterData.nonConformity.options = options
  }

  function _getAccounts (top, skip, search, accountIds = []) {
    const searchBy = 'company'

    const params = {
      top,
      skip,
      search,
      searchBy,
      accountIds
    }

    return SocialMediaService.getAccounts(socialType, params)
  }

  function _getContentType () {
    const contentType = [
      {
        value: 'STORY',
        label: 'Story'
      },
      {
        value: 'FEED',
        label: 'Feed'
      }
    ]

    return contentType
  }

  function _getNonConformity () {
    const nonConformity = [
      {
        value: true,
        label: $translate.instant('yes')
      },
      {
        value: false,
        label: $translate.instant('no')
      }
    ]

    return nonConformity
  }

  function _getGroups (top, skip, search) {
    const simplified = null
    const isAnalytics = false

    return GroupService.getGroups(top, skip, { searchTerm: search }, simplified, isAnalytics)
  }

  function _mountOptions (options) {
    return options.map(option => ({
      ...option,
      active: false,
      label: option?.name || option?.title || '',
      value: option?.id || option?.value
    }))
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return totalCount > responseLength
  }

  async function _getMoreResults (type, top, skip, search, totalCount) {
    const types = {
      accounts: () => api._getAccounts(top, skip, search),
      groups: () => api._getGroups(top, skip, search)
    }

    const response = await types[type]?.()

    const options = response?.d?.results || response.rows

    $timeout(() => {
      $scope.filterData[type].options = api._mountOptions(options)
      $scope.filterData[type].hasMoreResults = api._hasMoreResults(totalCount, options.length)
    })
  }

  async function _setAccountsFilterValue (accountId) {
    const top = $scope.filterData.accounts.top
    const skip = $scope.filterData.accounts.skip
    const search = ''

    const accountResponse = await api._getAccounts(top, skip, search, [accountId])
    const accountFromResponse = accountResponse.rows

    const account = $scope.filterData?.accounts?.options?.find?.(option => option.id === accountId)

    if (account?.length) {
      $scope.filterData.accounts.value = account
      $scope.filters.accounts = account.map(item => item.value)
      $scope.accountValue = account
      return
    }

    const accountItem = api._mountOptions(accountFromResponse)

    $scope.filterData.accounts.value = accountItem
    $scope.filters.accounts = accountItem.map(item => item.value)
    $scope.accountValue = accountItem
  }
}

export { AuditSocialMediaFiltersController }
